"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const yup = __importStar(require("yup"));
const react_hook_form_1 = require("react-hook-form");
const yup_1 = require("@hookform/resolvers/yup");
const react_1 = require("react");
const sweetalert2_1 = __importDefault(require("sweetalert2"));
const Utils_1 = require("../../../../utils/Utils");
const user_api_1 = require("../../../../utils/api/user/user.api");
const theme_1 = require("../../../../utils/theme");
const hook_1 = require("../../../../redux/hook");
function UseFormChangePassword() {
    const validationSchema = yup.object().shape({
        current_password: yup
            .string()
            .required("L'ancien mot de passe est obligatoire"),
        password: (0, Utils_1.validatePassword)(yup),
        password_confirmation: yup
            .string()
            .oneOf([yup.ref("password")], "veuillez entrer des mots de passe identiques."),
    });
    const { register, handleSubmit, formState: { errors }, clearErrors, setError, reset, setValue, } = (0, react_hook_form_1.useForm)({
        resolver: (0, yup_1.yupResolver)(validationSchema),
    });
    const { user } = (0, hook_1.useAppSelector)((state) => state.user);
    const [changePassword, { isLoading, isSuccess, error, isError }] = (0, user_api_1.useUpdateAuthPasswordMutation)();
    const [haveMinUppercase, setHaveMinUppercase] = (0, react_1.useState)(false);
    const [haveMinLowercase, setHaveMinLowercase] = (0, react_1.useState)(false);
    const [haveMinNumber, setHaveMinNumber] = (0, react_1.useState)(false);
    const [haveMinCharacter, setHaveMinCharacter] = (0, react_1.useState)(false);
    const [haveMinSpecialCharacter, setHaveMinSpecialCharacter] = (0, react_1.useState)(false);
    const [PasswordInput, setPasswordInput] = (0, react_1.useState)();
    const countUppercase = (str) => {
        var _a;
        if (((_a = str.replace(/[^A-Z]/g, "")) === null || _a === void 0 ? void 0 : _a.length) >= 1) {
            return true;
        }
        return false;
    };
    const countLowercase = (str) => {
        var _a;
        if (((_a = str.replace(/[^a-z]/g, "")) === null || _a === void 0 ? void 0 : _a.length) >= 1) {
            return true;
        }
        return false;
    };
    const countNumber = (str) => {
        var _a;
        if (((_a = str.replace(/[^0-9]/g, "")) === null || _a === void 0 ? void 0 : _a.length) >= 1) {
            return true;
        }
        return false;
    };
    const countCharacters = (str) => {
        if ((str === null || str === void 0 ? void 0 : str.length) >= 8) {
            return true;
        }
        return false;
    };
    const countSpecial = (str) => {
        const punct = `/[!@#$%^&*()_+\\-=\\[\\]{};':"\\|,.<>\\/?]+/;`;
        let count = 0;
        for (let i = 0; i < (str === null || str === void 0 ? void 0 : str.length); i++) {
            if (!punct.includes(str[i])) {
                continue;
            }
            count++;
        }
        // return count;
        if (count >= 1) {
            return true;
        }
        return false;
    };
    const passwordHandleChange = (e) => {
        var password = e.target.value;
        setPasswordInput(password);
        if (countUppercase(password)) {
            setHaveMinUppercase(true);
        }
        else {
            setHaveMinUppercase(false);
        }
        if (countLowercase(password)) {
            setHaveMinLowercase(true);
        }
        else {
            setHaveMinLowercase(false);
        }
        if (countNumber(password)) {
            setHaveMinNumber(true);
        }
        else {
            setHaveMinNumber(false);
        }
        if (countCharacters(password)) {
            setHaveMinCharacter(true);
        }
        else {
            setHaveMinCharacter(false);
        }
        if (countSpecial(password)) {
            setHaveMinSpecialCharacter(true);
        }
        else {
            setHaveMinSpecialCharacter(false);
        }
        setValue("password", e.target.value);
    };
    const passwordHandleReset = () => {
        reset();
        setHaveMinUppercase(false);
        setHaveMinLowercase(false);
        setHaveMinNumber(false);
        setHaveMinCharacter(false);
        setHaveMinSpecialCharacter(false);
    };
    (0, react_1.useEffect)(() => {
        if (errors) {
            setTimeout(() => {
                Object.entries(errors).map(([key]) => clearErrors(key));
            }, 4000);
        }
    }, [errors, clearErrors]);
    const onSubmit = (data) => __awaiter(this, void 0, void 0, function* () {
        var _a, _b, _c, _d, _e, _f;
        const res = yield changePassword({
            id: user === null || user === void 0 ? void 0 : user.user_id,
            data: data,
        });
        if (((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.matched) === false) {
            setError("current_password", {
                message: (_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.message,
            });
        }
        else if (((_c = res === null || res === void 0 ? void 0 : res.data) === null || _c === void 0 ? void 0 : _c.matched) === true && ((_d = res === null || res === void 0 ? void 0 : res.data) === null || _d === void 0 ? void 0 : _d.success) === true) {
            sweetalert2_1.default.fire({
                icon: "success",
                title: "Mot de passe modifiée avec succès!",
                iconColor: theme_1.Color.success,
                showConfirmButton: false,
                timer: 3000,
            }).then(() => {
                passwordHandleReset();
            });
        }
        else {
            sweetalert2_1.default.fire({
                icon: "error",
                title: ((_e = res === null || res === void 0 ? void 0 : res.data) === null || _e === void 0 ? void 0 : _e.message)
                    ? (_f = res === null || res === void 0 ? void 0 : res.data) === null || _f === void 0 ? void 0 : _f.message
                    : "Une erreur a survenue lors de la modification",
                showConfirmButton: false,
                timer: 3000,
            });
        }
        ;
    });
    return {
        register,
        errors: errors,
        onSubmit: handleSubmit(onSubmit),
        isLoading,
        passwordHandleChange,
        haveMinCharacter,
        haveMinLowercase,
        haveMinNumber,
        haveMinSpecialCharacter,
        haveMinUppercase,
        passwordHandleReset,
        PasswordInput,
    };
}
exports.default = UseFormChangePassword;
